export const googleReviewsData = {
	businessName: "Steer Smart Driving School",
	overallRating: 5.0,
	totalReviews: 48,
	reviews: [
		{
			id: 1,
			author: "evy bowman",
			rating: 5,
			date: "3 weeks ago",
			text: "The instructor was very efficient, highly qualified, well at teaching, great instructions. The best at reverse parallel parking. I say it's the best school in canberra, highly recommend. Overall a nice person :)",
			reviewCount: 5,
			photoCount: 1,
			isNew: true,
		},
		{
			id: 2,
			author: "Rebecca Hennessy",
			rating: 5,
			date: "2 months ago",
			text: "I would 100% recommend steer smart driving school the instructor was very patient and put me at ease.they gave me great techniques to learn especially with reverse parallel parking where I had failed in the past. Very helpful and reliable.",
			reviewCount: 2,
			photoCount: 0,
		},
		{
			id: 3,
			author: "Michael Koch",
			rating: 5,
			date: "4 months ago",
			text: "I had an excellent learning experience. I began learning from zero, never having driven a car, and quickly became confident in driving, all at an affordable price. The calm, thorough and friendly instructor was all I needed guiding me through all the competencies and the tests. I highly recommend this school to everyone and especially to beginners.",
			reviewCount: 5,
			photoCount: 5,
		},
		{
			id: 4,
			author: "Clarissa Gea",
			rating: 5,
			date: "4 months ago",
			text: "im so grateful to find this driving school. my instructor was so kind and patient and taught me with full knowledge. he was so flexible as well in terms of schedule and hes very passionate about what he does. good techniques and very understanding. would recommend anyone to go to this driving school⭐️⭐️⭐️⭐️⭐️",
			reviewCount: 4,
			photoCount: 0,
		},
		{
			id: 5,
			author: "Nazdana Hussaini",
			rating: 5,
			date: "7 months ago",
			text: "I had tried many driving schools in Canberra, took lessons with multiple instructors, and even failed the test still struggling to make progress. Then I joined Steer Smart Driving School, and it made all the difference. I passed my test after just 5 lessons! The instructors are friendly, professional, and highly experienced. I highly recommend them an excellent choice for anyone wanting to learn effectively and build real confidence on the road.",
			reviewCount: 3,
			photoCount: 0,
		},
		{
			id: 6,
			author: "Jeann Navarro",
			rating: 5,
			date: "3 months ago",
			text: "The instructor is so knowledgeable and very patient with me. I am a newly learner and I appreciate the patience that the instructor given me. Strongly recommend this school. Thank you for my license.",
			reviewCount: 5,
			photoCount: 0,
		},
		{
			id: 7,
			author: "Ashab Abid Pathan",
			rating: 5,
			date: "8 months ago",
			text: "Steer Smart Driving School is one of Canberra's best. I can not thank enough to my instructor, whom helped me a lot to secure my full Driver's licence in one attempt from Service NSW Queanbeyan. My instructor was very respectful, sincere, punctual and friendly. He taught me few easiest tricks regarding reverse parallel parking, 3 point turn, 5 point turn, kerb side stop and furthermore continuous shoulder check. He helped me to be confident and believe in myself. My instructor was a kind person. They helped me to get my full driver's license in 1 attempt, I am giving them 5 stars. I recommend Steer Smart Driving school.",
			reviewCount: 3,
			photoCount: 0,
		},
		{
			id: 8,
			author: "Ryan Jin",
			rating: 5,
			date: "2 months ago",
			text: "Passed the driving assessment after two sessions lesson. The instructor is very experienced and pointed out many issues of my driving.",
			reviewCount: 23,
			photoCount: 0,
			isLocalGuide: true,
		},
		{
			id: 9,
			author: "raees ahmad",
			rating: 5,
			date: "10 months ago",
			text: "I recently passed my driving test with the help of Steer Driving school. My instructor was absolutely fantastic. He was patient, knowledgeable, and made me feel at ease behind the wheel.\n\nHis teaching methods were clear and concise, and he tailored their lessons to my individual needs. They helped me build confidence and improve my driving skills dramatically.\n\nI would highly recommend Steer Driving school to anyone looking for a reliable and supportive driving school. They truly deserve 5 stars!",
			reviewCount: 5,
			photoCount: 0,
			reactions: { heart: 1 },
		},
		{
			id: 10,
			author: "Ish Singh",
			rating: 5,
			date: "10 months ago",
			text: "Passed my driving test with steer smart driving school. Very comfortable learning experience, teacher always looking for ways where the student can improve and applies a variety of learning strategies such as acronyms to help students improve their driving ability. The instructor was very knowledgeable and I highly recommend this school for future students.",
			reviewCount: 1,
			photoCount: 0,
		},
		{
			id: 11,
			author: "sasha Absolon",
			rating: 5,
			date: "7 months ago",
			text: "Thanks to Steer Smart Driving School, I passed and got my P's within a month. My instructor was extremely helpful and brilliant at teaching me, being careful and resilient to help me on the road to the best of my abilities.",
			reviewCount: 1,
			photoCount: 0,
		},
		{
			id: 12,
			author: "Qingze Han",
			rating: 5,
			date: "9 months ago",
			text: "The instructor was very experienced and had a fantastic and pleasant teaching approach. I would highly recommend Steer Smart Driving School for any learner driver for a smooth transition to their provisional license!",
			reviewCount: 3,
			photoCount: 0,
		},
		{
			id: 13,
			author: "Ziaul Alam Moshi",
			rating: 5,
			date: "5 months ago",
			text: "The instructor is very good and professional. His instructions are really helpful. Today I have passed my ACT driving test. ( Alhamdulillah)",
			reviewCount: 11,
			photoCount: 0,
			isLocalGuide: true,
		},
	],
};
